import React, { useContext } from 'react'
import { PERMISSIONS } from '@Const/permissions'
import Navigation from '@App/navigation'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import ExpandableItem from '../../Sidebar/ExpandableItem'
import { NavLink } from 'react-router'
import RequireFeatureFlag from '@App/kit/components/Utility/RequireFeatureFlag'

const CatalogSubNavigation = () => {
    const { rightsholderStore } = useContext(StoresContext)

    return (
        <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
            <ExpandableItem
                heading="Catalog"
                icon={ICONS.catalog}
                link={Navigation.rightholder.catalog.root(rightsholderStore.currentRightsholderId)}
            >
                <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.manage_works]} orIsInternal>
                    <NavLink to={Navigation.rightholder.catalogTransfer.root(rightsholderStore.currentRightsholderId)}>
                        Catalog Transfer Tool
                    </NavLink>
                </PermissionCheck>
                <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
                    <RequireFeatureFlag flagKey="rightsholder-change-requests">
                        <NavLink
                            to={Navigation.rightholder.catalog.changeRequests.root(
                                rightsholderStore.currentRightsholderId
                            )}
                        >
                            Change Requests
                        </NavLink>
                    </RequireFeatureFlag>
                </PermissionCheck>
            </ExpandableItem>
        </PermissionCheck>
    )
}

export default CatalogSubNavigation
